import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs, urlParams } from '@ctct/infrastructure-layer';

const isStripeEnabledViaURLParam = urlParams.getIfStripeTurnedOn();

export const useIsStripeEnabled = (isTrialer: undefined | boolean) => {
  if (envs.isSecure()) {
    return {
      data: isTrialer ? isStripeEnabledViaURLParam : false,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'enable_payflow_stripe',
    defaultValue: isStripeEnabledViaURLParam,
    preConditions: isTrialer,
  });
};
